import { i18n } from 'src/i18n';

export default [
  {
    name: 'username',
    label: i18n('entities.appUser.fields.username'),
  },
  {
    name: 'nationalID',
    label: i18n('entities.appUser.fields.nationalID'),
  },
  {
    name: 'name',
    label: i18n('entities.appUser.fields.name'),
  },
  {
    name: 'lastName',
    label: i18n('entities.appUser.fields.lastName'),
  },
  {
    name: 'birthDate',
    label: i18n('entities.appUser.fields.birthDate'),
  },
  {
    name: 'rolName',
    label: i18n('entities.appUser.fields.rolName'),
  },
  {
    name: 'areaName',
    label: i18n('entities.appUser.fields.areaName'),
  },
];
